import { createContext, type ReactNode, useCallback, useContext, useRef } from "react";

interface OmniboxContextValue {
  /** Ref populated by the Omnibox to allow imperative prefilling. */
  prefillRef: React.MutableRefObject<((text: string) => void) | null>;
  /** Prefill the Omnibox text imperatively (works even with the same text twice). */
  setInputPrefill: (prefill: string) => void;
}

const OmniboxContext = createContext<OmniboxContextValue>({
  prefillRef: { current: null },
  setInputPrefill: () => {},
});

export const useOmniboxContext = () => {
  return useContext(OmniboxContext);
};

export const OmniboxProvider = ({ children }: { children: ReactNode }) => {
  const prefillRef = useRef<((text: string) => void) | null>(null);

  const setInputPrefill = useCallback((text: string) => {
    prefillRef.current?.(text);
  }, []);

  return (
    <OmniboxContext.Provider value={{ prefillRef, setInputPrefill }}>
      {children}
    </OmniboxContext.Provider>
  );
};
